export default __webpack_public_path__ + "static/media/dexes.9a3edd68.svg";